<template>
  <div class="soar-container">
    <FilevaliditySkeleton v-if="loading"></FilevaliditySkeleton>
    <template v-else>
      <div class="flex items-center justify-center">
        <div class="w-[370px] flex flex-col items-center justify-center my-8 px-4">
          <h1 class="text-gray-500 text-xl font-bold tracking-wide leading-5 py-4">
            {{ $t('forgotPassword') }}
          </h1>
          <ForgotBanner v-if="isNotified" />
          <Form ref="form" class="w-full p-4 flex flex-col items-center" @submit="onSubmit" v-else>
            <div class="border border-1 border-gray-300 w-full rounded p-3">
              <Field
                :rules="validateEmail"
                name="email"
                v-slot="{ field, errors: errs }"
                class="w-full"
              >
                <SimpleTextInput
                  :field="field"
                  :errors="errs"
                  :label="$t('email')"
                  :popover-content="$t('EmailMaxValid')"
                  class="w-full flex-col pb-1"
                  direction="flex-col"
                />
              </Field>
            </div>
            <div class="flex items-center justify-center my-6">
              <GRecaptcha
                ref="gRecaptchaRef"
                @successCallback="recaptchaCall"
                class="w-full"
              ></GRecaptcha>
            </div>
            <div class="w-full flex justify-center px-1">
              <FilledButton
                class="w-full py-2.5 text-white"
                :disabled="isDisabled"
                as="button"
                type="submit"
              >
                {{ $t('send') }}
              </FilledButton>
            </div>
          </Form>
        </div>
      </div>
    </template>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { Field, Form } from 'vee-validate'
import SimpleTextInput from '@/components/SimpleForm/TextInput.vue'
import axiosInstance from '@/services'
import FilledButton from '@/components/Buttons/Filled.vue'
import GRecaptcha from '@/components/GRecaptcha/index.vue'
import { useI18n } from 'vue-i18n'
import ForgotBanner from '@/components/Banner/Forgot.vue'
import { notify } from 'notiwind'

const i18n = useI18n()

const loading = ref(false)
const form = ref()
const isDisabled = ref(false)
const gRecaptchaRef = ref(false)
const isNotified = ref(false)

function validateEmail(value) {
  if (!value || !`${value}`.trim()) {
    return i18n.t('INVALID_REQUIRED')
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  if (!emailRegex.test(value)) {
    return i18n.t('INVALID_EMAIL')
  }

  return true
}

const recaptchaCall = (validate) => {
  if (!validate) {
    isDisabled.value = true
  }
  isDisabled.value = !validate
}

const onSubmit = async (values) => {
  isNotified.value = false
  const recaptcha = gRecaptchaRef.value.validate()
  if (!recaptcha) {
    notify(
      {
        group: 'error',
        title: i18n.t('captchaNotProcessed')
      },
      6000
    )
    return
  }
  const payload = {
    userName: values?.email,
    recaptchaResponse: recaptcha
  }
  try {
    await axiosInstance.post(`/api/user/forgotPassword`, payload)
    isNotified.value = true
  } catch (error) {
    console.error(error, 'error')
  }
}

onMounted(() => {
  isNotified.value = false
})
</script>
